import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e7676ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-container" }
const _hoisted_2 = { class: "image-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "text-container" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "text-s-light" }
const _hoisted_7 = { class: "bottom-container" }
const _hoisted_8 = {
  key: 1,
  class: "text-empty-state"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_content_loader = _resolveComponent("base-content-loader")!
  const _component_contact_link = _resolveComponent("contact-link")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createBlock(_component_base_card, null, {
    default: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_base_content_loader, { key: 0 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.projectManager)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("img", {
                        src: _ctx.projectManager.avatarSrc,
                        alt: "Profile picture",
                        class: "image"
                      }, null, 8, _hoisted_3)
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.projectManager.name), 1),
                      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.translate('shared.projectManager')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    (_ctx.projectManager.email)
                      ? (_openBlock(), _createBlock(_component_contact_link, {
                          key: 0,
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.trackContact('email', _ctx.contactType))),
                          href: _ctx.projectManager.mailtoHref || `mailto:${_ctx.projectManager.email}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.translate('shared.email')), 1)
                          ]),
                          _: 1
                        }, 8, ["href"]))
                      : _createCommentVNode("", true),
                    (_ctx.projectManager.phone)
                      ? (_openBlock(), _createBlock(_component_contact_link, {
                          key: 1,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.trackContact('phone', _ctx.contactType))),
                          href: `tel:${_ctx.projectManager.phone}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.translate('shared.call')), 1)
                          ]),
                          _: 1
                        }, 8, ["href"]))
                      : _createCommentVNode("", true)
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.translate('emptyState.contacts.projectManager')), 1))
          ], 64))
    ]),
    _: 1
  }))
}